import { PARTITION } from './constants';
import { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];
const selectConfiguration = (state: any) => selectPartition(state).configuration;
const selectIsConfigurationSet = (state: any) => selectPartition(state).isConfigurationSet;

export default {
  selectPartition,
  selectConfiguration,
  selectIsConfigurationSet,
};
